import { FormConfig } from '../../models/dynamic.model';

/* MAWB - Customize Columns */
export const MawbExcelColumnsList: string[] = [
  'mawb',
  'origin',
  'destination',
  'isPublished',
  'agentCode',
  'airlineCode',
  'clearanceType',
  'agentName',
  'airlineName',
  'linehaulCharge',
];

export const MawbColumnsList: string[] = [
  'select',
  ...MawbExcelColumnsList,
  'action',
];

/* Account payable - Customize Columns */
export const AccountPayableExcelColumnsList: string[] = [
  'invoiceNumber',
  'invoiceDate',
  'agentName',
  'agentCode',
  'invoiceReference',
  'incomingChargeCurrency',
  'conversionRate',
  'isPublish',
  'notes',
  'invoiceCharges',
];

export const AccountPayableColumnsList: string[] = [
  'select',
  ...AccountPayableExcelColumnsList,
  'action',
];

export const AccountReceivableColumnsList: string[] = [
  'invoiceNumber',
  'invoiceDate',
  'accountName',
  'accountNumber',
  'isPublish',
  'invoiceCharges',
];

export const AccountReceivableExcelColumnsList: string[] = [
  'select',
  ...AccountReceivableColumnsList,
  'action',
];

/* MAWB - Manifest Customize Columns */
export const MAWBManifestCustomizeColumns: string[] = [
  'select',
  'manifestNumber',
  'date',
  'bags',
  'shipments',
  'action',
];

/* MAWB - Manifest Customize Columns */
export const MAWBFlightCustomizeColumns: string[] = [
  'select',
  'flightNumber',
  'airlineCode',
  'arrivalDate',
  'slacCount',
  'slacWeight',
  'mawbPart',
  'action',
];

export const MawbPalletCustomizeColumns: string[] = [
  'select',
  'dimL',
  'dimW',
  'dimH',
  'dimensionalFactor',
  'dimensionalWeight',
  'actualWeight',
];

export const AgentColumnList: string[] = [
  'select',
  'code',
  'name',
  'types',
  'status',
  'serviceTypes',
  'fuelSurcharge',
  'action',
];

export const AgentFacilityColumnList: string[] = [
  'select',
  'facilityCode',
  'action',
];

export const shipmentCommodityColumnList: string[] = [
  'select',
  'commodityNumber',
  'hsCode',
  'value',
  'weight',
  'description',
  'action',
];

/* Manifest - Bag Customize Columns */
export const ManifestBagsCustomizeColumns: string[] = [
  'select',
  'bagExt',
  'shipments',
  'weight',
  'action',
];

export const bagPieceGridDisplayColumns: string[] = [
  'select',
  'hawbExt',
  'weight',
  'dimensions',
  'shipper',
  'consignee',
  'action',
];

export const selectTableMawbManifestFormfieldsConfig: FormConfig = {
  fields: [
    {
      id: 'searchInput',
      type: 'input',
      label: '',
      minValue: 1,
      maxValue: 25,
      allowAlphaNumericWithDotUnderscoreDashSpecialCharacters: true,
    },
  ],
};

export const selectTableManifestBagsFormfieldsConfig: FormConfig = {
  fields: [
    {
      id: 'searchInput',
      type: 'input',
      label: '',
      minValue: 3,
      maxValue: 126,
      isCheckForMaxValue: true,
      noInitialWhiteSpace: true,
    },
  ],
};

export const selectTableBagPieceFormfieldsConfig: FormConfig = {
  fields: [
    {
      id: 'searchInput',
      label: '',
      isCheckForMaxValue: true,
      minValue: 3,
      maxValue: 126,
      noInitialWhiteSpace: true,
      type: 'input',
      allowAlphaNumericWithDotUnderscoreDashSpecialCharacters: true,
    },
  ],
};

export const AutocompleteControls = [
  'airlineCode',
  'packagingTypeName',
  'codeAndDescription',
  'deliveryAgent',
  'rateScale',
  'location',
  'department',
  'role',
  'group',
  'agentChargeCode',
  'agentChargeType',
  'ibcChargeCode',
  'passThrough',
  'chargeType',
  'incomingChargeCurrency',
  'agentId',
  'chargeCode',
  'outTP',
  'serviceType',
  'modeOfTransport',
  'shipmentType',
];

export const ValueControls = [
  'commodityNumber',
  'pieceNumber',
  'userName',
  'attachments',
  'additionalDetails',
  'shipmentsLinked',
];

export const InputWithDecimalValidationKeys = [
  'slacWeight',
  'value',
  'weight',
  'conversionRate',
  'chargeAmount',
  'incomingChargeAmount',
  'minWeight',
  'maxWeight',
  'charge',
];

export const InputWithoutValidationKeys = [
  'slacCount',
  'hsCode',
  'description',
  'additionalInformation',
  'startNumber',
  'endNumber',
  'lastUsedNumber',
  'priority',
  'agentId',
  'invoiceNumber',
  'agentChargeCode',
  'incomingChargeCurrency',
  'shipmentIdentifierValue',
  'published',
  'chargeDescription',
  'routingDeliveryAgent',
  'origin',
  'destination',
  'journey',
  'duration',
  'startingTime',
  'arrivalTime',
  'availability',
  'availabilies',
];

export const InputWithAlphaNumbers = ['flightNumber'];

export const AccountColumnList: string[] = [
  'select',
  'accountNumber',
  'accountName',
  'organizationName',
  'shipments',
  'additionalInfo',
  'action',
];

export const InputWithAlphaNumbersHyphen = ['pieceExt'];

export const InputWithNumbers = [
  'dimLWH',
  'dimL',
  'dimW',
  'dimH',
  'location',
  'department',
  'role',
];

export const PalletsKeys = [
  'dimL',
  'dimW',
  'dimH',
  'dimensionalFactor',
  'dimensionalWeight',
  'actualWeight',
];

export const InputControls = [
  'startNumber',
  'endNumber',
  'firstName',
  'lastName',
  'email',
  'fullName',
  'agentChargeDescription',
  'flatFee',
  'chargeAmount',
  'deliveryZone',
  'postalStart',
  'postalEnd',
  'description',
  'addAgentMarkupCharges',
  'markUp',
  'shipmentIdentifierValue',
  'incomingChargeAmount',
  'conversionRate',
  'chargeAmount',
  'destination',
  'weight',
  'agentChargeDescription',
  'shipmentId',
  'shipmentIdOrMawbId',
  'chargeDescription',
  'invoiceNumber',
  'arInvoiceNumber',
  ...PalletsKeys,
  'transitPoints',
  'inTP',
  'inTPDate',
  'outTPDate'
];

export const PostalCodeKeys = ['postalStart', 'postalEnd'];

export const DatePickerKeys = ['invoiceDate'];

export const MarkUpKey = ['markUp'];

export const ChargeAmountKey = ['chargeAmount'];

export const IdentifierKey = ['shipmentIdentifierValue'];

export const ChargeAmountKeys = ['incomingChargeAmount', 'chargeAmount'];

export const TableControls = {
  airlineCode: 'airlineCode',
  packageType: 'packagingTypeName',
  arrivalDate: 'arrivalDate',
  dimLWH: 'dimLWH',
  dateTimeAndTimezone: 'dateTimeAndTimezone',
  codeAndDescription: 'codeAndDescription',
  deliveryAgent: 'deliveryAgent',
  rateScale: 'rateScale',
  markUp: 'markUp',
  location: 'location',
  department: 'department',
  role: 'role',
  group: 'group',
  ibcChargeCode: 'ibcChargeCode',
  agentChargeCode: 'agentChargeCode',
  chargeCode: 'chargeCode',
  agentChargeTypes: 'agentChargeType',
  apChargeType: 'chargeType',
  currency: 'incomingChargeCurrency',
  invoiceDate: 'invoiceDate',
  incomingChargeCurrency: 'incomingChargeCurrency',
  agentId: 'agentId',
  incomingChargeAmount: 'incomingChargeAmount',
  conversionRate: 'conversionRate',
  chargeAmount: 'chargeAmount',
  incomingChargeCurrencyId: 'incomingChargeCurrencyId',
  agentChargeCodeId: 'agentChargeCodeId',
  invoiceNumber: 'invoiceNumber',
  currencyCode: 'currencyCode',
  chargeCodeId: 'chargeCodeId',
  chargeDescription: 'chargeDescription',
  shipmentValue: 'shipmentValue',
  shipmentWeight: 'shipmentWeight',
  outTP: 'outTP',
};

export const ApiControls = {
  airlineCode: 'airlineId',
  packageType: 'packagingType',
  codeAndDescription: 'statusCodes',
  deliveryAgent: 'deliveryAgentId',
  rateScale: 'rateScaleId',
  location: 'locationId',
  department: 'departmentId',
  role: 'roleId',
  group: 'groupId',
  ibcChargeCode: 'ibcChargeCodeId',
  agentChargeCode: 'agentChargeCodeId',
  agentChargeTypes: 'agentChargeTypeId',
  apChargeType: 'chargeTypeId',
  outTP: 'outTPId',
};

export const desiredPackageIds = ['B', 'C', 'L', 'M', 'P', 'O', 'A', 'T'];

export const ShipmentGatewayPieceColumnList: string[] = [
  'shipmentGatewayShipment',
  'shipmentGatewayConsigneeName',
  'shipmentGatewayOrigin',
  'shipmentGatewayFinalDestination',
  'shipmentGatewayDateOfCreation',
  'shipmentGatewayWeights',
  'shipmentGatewayDimensions',
  'isGatewayed',
  'actions',
];

export const ShipmentGatewayPieceShortageColumnList: string[] = [
  'select',
  'shipmentGatewayShipment',
  'shipmentGatewayConsigneeName',
  'shipmentGatewayOrigin',
  'shipmentGatewayFinalDestination',
  'shipmentGatewayDateOfCreation',
  'shipmentGatewayWeights',
  'shipmentGatewayDimensions',
  'isGatewayed',
];

export const statusCodeColumnList: string[] = [
  'select',
  'dateTimeAndTimezone',
  'userName',
  'codeAndDescription',
  'attachments',
  'additionalDetails',
];

export const smStatusCodesColumnList: string[] = [
  'select',
  'statusCodeType',
  'agentName',
  'externalStatusCode',
  'statusCode',
  'locationName',
  'applicableFor',
  'description',
  'notes',
  'action',
];

export const smRolesAndPermissionsColumnList: string[] = [
  'select',
  'dept',
  'role',
  'facility',
  'information',
  'action',
];

export const gatewayMasterShipmentColumnList: string[] = [
  'masterShipment',
  'masterShipmentConsigneeName',
  'masterShipmentOrigin',
  'masterShipmentFinalDestination',
  'masterShipmentDateOfCreation',
  'isMasterShipmentGatewayed',
  'actions',
];

export const ShipmentBagColumnList: string[] = [
  'radioSelect',
  'hawbExt',
  'accountDetails',
  'consignee',
  'origin',
  'destination',
  'weight',
  'dimension',
];

export const UserManagementColumnList: string[] = [
  'select',
  'firstName',
  'lastName',
  'fullName',
  'email',
  'defaultLocation',
  'lastLoggedIn',
  'lastAccessedIpAddress',
  'noOfDepartments',
  'noOfRoles',
  'action',
];

export const UserDepartmentColumnList: string[] = [
  'select',
  'department',
  'role',
  'location',
];

export const UserLoginInformationColumnList: string[] = [
  'lastLoggedIn',
  'lastAccessedIpAddress',
];

export const customerServiceColumnList: string[] = [
  'select',
  'rateScale',
  'markUp',
];

export const AccountExcelColumnsList: string[] = [
  'accountNumber',
  'accountName',
  'organizationName',
  'shipments',
  'additionalInfo',
];

export const AccountColumnsList: string[] = [
  'select',
  ...AccountExcelColumnsList,
  'action',
];

export const accountUsersColumnList: string[] = ['select', 'fullName', 'email'];

export const RolesAndPermissionsColumnsList: string[] = [
  'select',
  'dept',
  'role',
  'facility',
  'information',
  'action',
];

export const UserDepartmentGridKeys: string[] = [
  'department',
  'departmentId',
  'role',
  'roleId',
  'location',
  'locationId',
];

export const AirportsColumnList: string[] = [
  'select',
  'airportCode',
  'icaoCode',
  'airportName',
  'countryCode',
  'information',
  'action',
];

export const NumberRangesColumnList: string[] = [
  'select',
  'numberRangeTypeName',
  'seriesName',
  'prefix',
  'facility',
  'setRange',
  'additionalInformation',
  'action',
];

export const AirlinesColumnList: string[] = [
  'select',
  'airlineCode',
  'icaoCode',
  'iataCode',
  'name',
  'address',
  'notes',
  'action',
];

export const FetchFullmanFilesColumnList: string[] = [
  'account',
  'dateTime',
  'fileName',
  'status',
  'processedHawbCount',
  'errorInfo',
  'fullmanParsedDataId',
];

export const CbpRequestStatusColumnList: string[] = [
  'dateTime',
  'hawbId',
  'mawbExt',
  'hawbExt',
  'origin',
  'destination',
  'status',
  'errorInfo',
  'requestedEdi',
  'cbpRequestInfoId',
];

export const CbpResponseStatusColumnList: string[] = [
  'dateTime',
  'hawbId',
  'mawbExt',
  'hawbExt',
  'origin',
  'destination',
  'status',
  'errorInfo',
  'responseInfo',
  'responseEdi',
];

export const CustomsCityDraftColumnList: string[] = [
  'hawbExt',
  'status',
  'skipAms',
  'createdAt',
  'retryCount',
  'maxRetries',
  'error',
  'customCityClearanceJobId',
];

export const CustomsCityAbiColumnList: string[] = [
  'entryNumber',
  'status',
  'mbolNumber',
  'hbolNumber',
  'createdAt',
  'entryType',
  'retryCount',
  'maxRetries',
  'cbpStatusCodes',
  'cbpStatusDescriptions',
  'error',
];

export const bagGatewyColumnList: string[] = [
  'noOfShipments',
  'shipper',
  'incomingManifest',
];

export const agentTypesColumnList: string[] = [
  'select',
  'agentType',
  'name',
  'description',
  'action',
];

export const hsCodeColumnList: string[] = [
  'select',
  'hsCode',
  'startDate',
  'endDate',
  'description',
  'aliasInformation',
  'action',
];

export const facilitiesColumnList: string[] = [
  'select',
  'facCode',
  'name',
  'facType',
  'facAddress',
  'country',
  'state',
  'city',
  'postalCode',
  'phone',
  'email',
  'description',
  'information',
  'action',
];

export const deliveryZoneColumnList: string[] = [
  'select',
  'deliveryZone',
  'agentCode',
  'agentName',
  'action',
];

export const FacilityExcelHeader: string[] = [
  'Code',
  'Name',
  'Type',
  'Address',
  'Country',
  'State/Province/Region',
  'City',
  'PostalCode',
  'Phone',
  'Email',
  'Description',
  'Information',
];

/** Must stay in 1:1 order with FacilityExcelHeader — not facilitiesColumnList (grid has select/action). */
export const facilityExcelColumnList: string[] = [
  'facCode',
  'name',
  'facType',
  'facAddress',
  'country',
  'state',
  'city',
  'postalCode',
  'phone',
  'email',
  'description',
  'information',
];

export const deliveryZoneInfoColList: string[] = [
  'select',
  'countryCode',
  'origin',
  'deliveryZone',
  'postalStart',
  'postalEnd',
];

export const serviceTypesColumnList: string[] = [
  'select',
  'serviceType',
  'name',
  'serviceTypeGroup',
  'description',
  'action',
];

export const routingColumnList: string[] = [
  'select',
  'origin',
  'destination',
  'transitPoints',
  'modesOfTransport',
  'action',
];

export const routingRoutesColumnList: string[] = [
  'select',
  'origin',
  'destination',
  'transitPoints',
  'modeOfTransport',
  'startingTime',
];

export const serviceTypeGroupsColumnList: string[] = [
  'select',
  'serviceTypeGroup',
  'name',
  'description',
  'notes',
  'action',
];

export const clearanceTypeGroupsColumnList: string[] = [
  'select',
  'clearanceType',
  'name',
  'description',
  'action',
];

export const AirlineColumnList: string[] = [
  'select',
  'airlineCode',
  'icaoCode',
  'iataCode',
  'name',
  'address',
  'notes',
];

export const AirportColumnList: string[] = [
  'select',
  'airportCode',
  'icaoCode',
  'airportName',
  'countryCode',
  'information',
];

export const NumberRangesConfigColumnList: string[] = [
  'select',
  'numberRangeTypeName',
  'seriesName',
  'prefix',
  'facility',
  'additionalInformation',
  'setRange',
  'action',
];
export const SetRangeColumnList: string[] = [
  'startNumber',
  'endNumber',
  'lastUsedNumber',
  'priority',
];

export const setRangeWithAction: string[] = [...SetRangeColumnList, 'action'];

export const linkedAccountColumnList: string[] = ['linkedAccount', 'details'];

export const measurementOptions = ['Pounds/Inches', 'Kilograms/Centimeters'];

export const ibcChargeCodeColumnList: string[] = [
  'select',
  'code',
  'description',
  'action',
];
export const apChargeCodeColumnList: string[] = [
  'select',
  'agentCode',
  'agentName',
  'description',
  'apChargeCodeDetails',
  'action',
];

export const apChargeCodeInfoColList: string[] = [
  'select',
  'agentChargeCode',
  'ibcChargeCode',
  'description',
  'agentChargeType',
];

export const rateScaleColumnList: string[] = [
  'select',
  'rateScale',
  'destination',
  'agent',
  'action',
];

export const rsAccessorialCharges: string[] = [
  'agentChargeCode',
  'agentChargeDescription',
  'ibcChargeCode',
  'chargeType',
  'passThrough',
  'addAgentMarkupCharges',
  'flatFee',
  'chargeAmount',
];

export const apChargeCodeDetailsColList: string[] = [
  'agentChargeCode',
  'ibcChargeCode',
  'chargeType',
  'description',
];
export const rsAccessorialManualEntry = [...rsAccessorialCharges, 'action'];

export const arSummaryTableColumnList: string[] = [
  'select',
  'invoiceNumber',
  'invoiceDate',
  'accountName',
  'accountNumber',
  'isPublish',
  'action',
];

export const arChargeCodeColumnList: string[] = [
  'select',
  'shipmentIdentifier',
  'shipmentIdentifierValue',
  'weight',
  'chargeCode',
  'chargeDescription',
  'chargeAmount',
  'shipmentIdOrMawbId',
];
export const APChargeCodeConfigColumnList: string[] = [
  'select',
  'agentCode',
  'agentName',
  'description',
  'apChargeCodeDetails',
  'action',
];
export const DeliveryZoneExcelHeader: string[] = [
  'Delivery Zone',
  'Agent Code',
  'Azent Name',
];

/** Must stay in 1:1 order with DeliveryZoneExcelHeader — not deliveryZoneColumnList (grid has select/action). */
export const deliveryZoneExcelColumnList: string[] = [
  'deliveryZone',
  'agentCode',
  'agentName',
];

export const RateScaleColumnList: string[] = [
  'select',
  'rateScale',
  'destination',
  'agent',
  'action',
];

export const RateScaleExcelHeader: string[] = [
  'Rate Scale',
  'Destination',
  'Agent',
];

/** Must stay in 1:1 order with RateScaleExcelHeader — not RateScaleColumnList (grid has select/action). */
export const rateScaleExcelColumnList: string[] = [
  'rateScale',
  'destination',
  'agent',
];

export const apSummaryGridColumnList: string[] = [
  'select',
  'invoiceNumber',
  'invoiceDate',
  'agentName',
  'agentCode',
  'invoiceReference',
  'incomingChargeCurrency',
  'conversionRate',
  'isPublish',
  'notes',
  'action',
];

export const apChargesForApModule: string[] = [
  'select',
  'shipmentIdentifier',
  'shipmentIdentifierValue',
  'incomingChargeAmount',
  'chargeAmount',
  'destination',
  'weight',
  'chargeType',
  'agentChargeCode',
  'agentChargeDescription',
  'shipmentId',
];

export const arChargesForARModule: string[] = [
  'select',
  'shipmentIdentifier',
  'shipmentIdentifierValue',
  'invoiceNumber',
  'chargeCode',
  'chargeDescription',
  'chargeAmount',
  'shipmentIdOrMawbId',
];

export const shipmentAndMawbArChargesTableColumnList: string[] = [
  'select',
  'invoiceNumber',
  'invoiceDate',
  'published',
  'chargeCode',
  'chargeAmount',
  'chargeDescription',
];

export const shipmentAndMawbApChargesTableColumnList: string[] = [
  'select',
  'agentId',
  'invoiceNumber',
  'invoiceDate',
  'agentChargeCode',
  'incomingChargeCurrency',
  'conversionRate',
  'incomingChargeAmount',
  'chargeAmount',
];

// SPEC-APL-001 AC-APL-001: Shipment AP grid only; MAWB keeps the list above.
export const shipmentApChargesTableColumnList: string[] = [
  'select',
  'invoiceNumber',
  'invoiceDate',
  'arInvoiceNumber',
  'agentId',
  'agentChargeCode',
  'incomingChargeCurrency',
  'conversionRate',
  'incomingChargeAmount',
  'chargeAmount',
];

export const selectInvoiceFromShipmentColumnList: string[] = [
  'invoiceNumber',
  'accountNumber',
  'invoiceDate',
  'chargeAmount',
  'selectInvoiceAction',
];

export const RsAccessorialChargesExcelHeader: string[] = [
  'AgentChargeCode',
  'AgentChargeDescription',
  'IBCChargeCode',
  'ChargeType',
  'PassThrough',
  'Markup%',
  'FlatFee',
  'ChargeAmount',
];

export const RsWeightBasedChargesExcelHeader: string[] = [
  'AgentServiceType',
  'IBCServiceType',
  'Weight',
  'Zone1',
  'Zone2',
  'Zone3',
  'Zone4',
  'Zone5',
];

export const APChargesExcelHeader: string[] = [
  'ShipmentIdentifier',
  'ShipmentIdentifierValue',
  'IncomingChargeAmount',
  'ChargeAmount',
  'Destination',
  'Weight',
  'ChargeType',
  'AgentChargeCode',
  'AgentChargeDescription',
  'ShipmentId/MAWBId',
];

export const ApSftpFilesColumnList: string[] = [
  'select',
  'agentData',
  'fileName',
  'fileDate',
  'invoiceNumber',
];

export const ManifestPublishAttachmentColumnList: string[] = [
  'displayName',
  'attachmentActions',
];

export const AgentInfoSectionHeaders: string[] = [
  'AgentCode',
  'InvoiceNumber',
  'InvoiceDate',
  'InvoiceReference',
  'IncomingChargeCurrency',
  'ConversionRate',
];
export const ScanShipmentBag: string[] = [
  'radioSelect',
  'hawbExt',
  'origin',
  'destination',
  'consignee',
  'shipper',
  'dimensions',
  'weight',
];

export const ManifestMultipleBagSelectionColumns: string[] = [
  'radioSelect',
  'bagExt',
  'origin',
  'destination',
  'shipments',
  'weight',
  'mawb',
];

export const AgentTrackingSelectionColumns: string[] = [
  'select',
  'shipment',
  'agentTrackingNumber',
  'weight',
  'destination',
  'invoiceNumber',
  'action',
];

export const scannedBagsTableColumnList: string[] = [
  'select',
  'bagExt',
  'origin',
  'destination',
  'shipments',
  'weight',
];
export const currencyManagementColumnList: string[] = [
  'select',
  'currencyCode',
  'currencyName',
  'conversionRate',
  'viewDetails',
  'action',
];

export const currencyDetailsColumnList: string[] = [
  'updatedDate',
  'updatedByName',
  'previousConversionRate',
  'updatedConversionRate',
];

export const apDashboardUnpublishedInvoicesTableColumnList: string[] = [
  'invoiceNumber',
  'agent',
  'invoiceDate',
  'latestStatusCode',
];

export const apDashboardRecentInvoicesTableColumnList: string[] = [
  'invoiceNumber',
  'agent',
  'invoiceDate',
  'createdDateTime',
];

export const arDashboardInvoicesYetToSendToGPTableColumnList: string[] = [
  'invoiceNumber',
  'accountNumber',
  'accountName',
  'invoiceDate',
];

export const arDashboardInvoicesYetToSendToCustomerTableColumnList: string[] =
  arDashboardInvoicesYetToSendToGPTableColumnList;

export const arDashboardSpecialShipmentsYetToBeInvoicedTableColumnList: string[] =
  ['shipmentNumber', 'accountNumber', 'accountName', 'shipmentDate'];

export const routesSelectionTableColumnList: string[] = [
  'radioSelect',
  'origin',
  'transitPoints',
  'destination',
  'modeOfTransport',
  'startingTime',
  'arrivalTime',
  'duration',
  'minMaxWeight',
  'minMaxValue',
  'availability',
  'charges',
];

export const hawbFinalDestRoutingConfirmColumnList: string[] = [
  'transitPointOrder',
  'originCode',
  'destinationCode',
];

export const transitPointsTableColumnList: string[] = [
  'transitPoints',
  'inTP',
  'inTPDate',
  'outTP',
  'outTPDate',
  'action',
];

export const accountRoutingCriteriaColumnList: string[] = [
  'select',
  'serviceType',
  'shipmentValue',
  'shipmentWeight',
  'modeOfTransport',
  'shipmentType',
];

export const transitPointsInlineColumnList: string[] = [
  'select',
  'originDisplay',
  'destinationDisplay',
  'modeOfTransportDisplay',
  'startingTime',
  'arrivalTime',
  'duration',
  'minMaxWeightDisplay',
  'availabilityDisplay',
  'charge',
];

export const ARMultiShipmentSelectionColumns = [
  'select',
  'shipment',
  'agentTrackingNumber',
  'weight',
  'destination',
  'invoiceNumber',
  'rated',
  'action',
];

export const AssociateUfoShipmentsColumns = [
  'select',
  'hawbExt',
  'shipmentCreatedDateAndTime',
  'shipperConsigneeName',
  'weight',
];
